module.exports = __webpack_public_path__ + "media/components/country-flag/static/us-f715ad55665a1325981b6334e3d1aa90.svg";